var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) if (e.indexOf(p[i]) < 0)
            t[p[i]] = s[p[i]];
    return t;
};
// necessary import format
// see https://stackoverflow.com/questions/44547201/typescript-react-not-importing-correctly
import * as React from 'react';
import { checkForRenderProp } from './helpers/checkers';
var FormProviderComponent = /** @class */ (function (_super) {
    __extends(FormProviderComponent, _super);
    function FormProviderComponent() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FormProviderComponent.prototype.render = function () {
        var _a = checkForRenderProp(this.props), render = _a.render, other = __rest(_a, ["render"]);
        return render(other);
    };
    return FormProviderComponent;
}(React.Component));
export { FormProviderComponent };
//# sourceMappingURL=FormProvider.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/yarfl/es/FormProvider.js
// module id = 344
// module chunks = 0